export default __webpack_public_path__ + "static/media/zertiassist_iconos_security_24px.dd027267.svg";